import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SESSION_EXPIRED_EVENT } from "../services/api";
import { APP_ROUTES } from "../constants";
import { safeReset } from "../utils/posthog";

/**
 * Hook that handles session expired events (LINK_NOT_FOUND or LINK_EXPIRED errors from API)
 * When triggered, it navigates to the dedicated session expired page.
 * The session expired page reads sessionExpiredRedirectUrl from the partner store.
 */
export function useSessionExpiredHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleSessionExpired = () => {
      // Don't redirect if already on session expired or error page
      if (
        location.pathname === APP_ROUTES.SESSION_EXPIRED_PAGE ||
        location.pathname === APP_ROUTES.SERVICE_UNAVAILABLE_PAGE ||
        location.pathname === APP_ROUTES.ERROR_PAGE
      ) {
        return;
      }

      safeReset();
      navigate(APP_ROUTES.SERVICE_UNAVAILABLE_PAGE, {
        replace: true, // Replace current history entry so user can't go back
      });
    };

    // Listen for session expired event
    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);

    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    };
  }, [navigate, location.pathname]);
}
